import logo from './logo.svg';
import './App.css';
const domain = window.location.host;

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          {domain} Coming Soon 
        </p>       
      </header>
    </div>
  );
}

export default App;
